let organizationData = undefined;
let lastSearchedCep = undefined;

async function getAccountAddresses() {
  try {
    const token = await login();

    const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations/addresses?customerId=${customerId}&active=false`;
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });
    const jsonData = await response.json();

    if (!response.ok) throw jsonData;

    return jsonData;
  } catch (error) {
    const errorMessage = typeof error === "object" ? JSON.stringify(error) : error;
    console.error(`[getAccountAddresses] - Could not retrieve account addresses. Error: ${errorMessage}`);
  }
}

async function getAddressOrganizationData() {
  try {
    if (organizationData) return;

    const token = await login();
    const url = cnpjR
      ? `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations?customerId=${customerId}&organizationRootDocument=${cnpjR}`
      : `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations?customerId=${customerId}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const organizationInfo = await response.json();

    organizationData = organizationInfo[0];
  } catch (error) {
    console.log(error);
    showAddressError(`Não foi possível recuperar os dados da organização.`);
  }
}

function renderAccountAddresses(addresses) {
  try {
    const addressesContainer = document.getElementById("address-container");
    if (!addressesContainer) throw `Address container element not found`;

    const newAddressElement = addressesContainer.querySelector('#address-new');
    if (!newAddressElement) throw `New address element not found`;

    const addressIconElement = addressesContainer.querySelector('.address-icon');

    for (const address of addresses) {
      const locationId = address?.shopifyLocationId?.split('/').at(-1) || address.externalId;
      const addressInfo = `${address.address1}, ${address.address2}${address.county ? ` - ${address.county}` : ''}${address.address3 ? `, ${address.address3}` : ''}`;

      if(!address.active && address.erpIdToShip) continue;

      let isCurrentAddress = false;

      const existingAddressElement = locationId ? addressesContainer.querySelector(`#address-${locationId}`) : undefined;
      if (existingAddressElement) {
        if (existingAddressElement.classList.contains('current-address')) isCurrentAddress = true;
        addressesContainer.removeChild(existingAddressElement);
      };

      const addressContainer = document.createElement('div');
      addressContainer.id = `address-${locationId}`;
      addressContainer.classList.add('dados', 'address-dados');
      addressesContainer.appendChild(addressContainer);

      if (addressIconElement)
        addressContainer.appendChild(addressIconElement.cloneNode(true));

      const addressInfoContainer = document.createElement('div');
      addressInfoContainer.classList.add('address-info');
      addressContainer.appendChild(addressInfoContainer);

      const badgesContainer = document.createElement('div');
      badgesContainer.classList.add('address-badges');
      addressInfoContainer.appendChild(badgesContainer);

      if (isCurrentAddress) {
        const currentAddressBadgeElement = document.createElement('span');
        currentAddressBadgeElement.classList.add('address-badge', 'visible', 'current-address');
        currentAddressBadgeElement.innerText = 'Endereço selecionado';
        badgesContainer.appendChild(currentAddressBadgeElement);
      }

      const addressBadgeElement = document.createElement('span');
      const addressBadgeClasses = ['address-badge', 'visible'];

      if (address.active) {
        addressBadgeClasses.push('active');
        addressBadgeElement.innerText = "Ativo";
      }
      // else if (address.erpIdToShip) {
      //   addressBadgeClasses.push('disabled');
      //   addressBadgeElement.innerText = "Inativo";
      // }
      else {
        addressBadgeClasses.push('in-analisis');
        addressBadgeElement.innerText = "Em análise";
      }

      addressBadgeElement.classList.add(...addressBadgeClasses);
      badgesContainer.appendChild(addressBadgeElement);

      const addressStreetElement = document.createElement('p');
      addressStreetElement.innerText = addressInfo.split(' ').map(word =>
        String(word).charAt(0).toUpperCase() +
        String(word).toLowerCase().slice(1)
      ).join(' ');
      addressInfoContainer.appendChild(addressStreetElement);

      const addressCityElement = document.createElement('span');
      addressCityElement.innerText = `${address.city}/${address.state}`;
      addressInfoContainer.appendChild(addressCityElement);

      const addressPostalCodeElement = document.createElement('span');
      const parsedPostalCode = String(address.postalCode).replace('-', '');
      addressPostalCodeElement.innerText = `CEP: ${parsedPostalCode.slice(0, 5)}-${parsedPostalCode.slice(5)}`;
      addressInfoContainer.appendChild(addressPostalCodeElement);
    }

    addressesContainer.appendChild(newAddressElement);
  } catch (error) {
    console.error(`[getAccountAddresses] - Could not render account addresses.`);
    console.error(error);
  }
}

async function loadAddressData() {
  const addresses = await getAccountAddresses();
  renderAccountAddresses(addresses);
}

function openAddressModal() {
  getAddressOrganizationData();

  const modal = document.querySelector(".custom-modal");
  if (!modal) {
    console.error("❌ Modal não encontrado");
    showToast('error', 'Não foi possível abrir o modal de endereço. Tente novamente.', 'FECHAR');
    return;
  }

  const closeIcon = `<svg width="20" height="20" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m1.5 1.5 7 7M8.5 1.5l-7 7" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  const searchIcon = `<svg width="23.52" height="23.52" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.62233 18.1333C6.21256 18.1333 4.173 17.2981 2.50367 15.6277C0.834556 13.9574 0 11.9334 0 9.55567C0 7.17789 0.835222 5.15378 2.50567 3.48334C4.17589 1.81289 6.20367 0.977669 8.589 0.977669C10.9741 0.977669 12.9981 1.81289 14.661 3.48334C16.3241 5.15378 17.1557 7.179 17.1557 9.559C17.1557 10.5197 17.0001 11.4408 16.689 12.3223C16.3779 13.2037 15.926 14.0148 15.3333 14.7557L23.2 22.5777C23.4149 22.7859 23.5223 23.051 23.5223 23.373C23.5223 23.6948 23.4149 23.963 23.2 24.1777C22.9851 24.3926 22.7168 24.5 22.395 24.5C22.0732 24.5 21.8082 24.3926 21.6 24.1777L13.7557 16.3333C13.089 16.8962 12.3152 17.337 11.4343 17.6557C10.5534 17.9741 9.61611 18.1333 8.62233 18.1333ZM8.6 15.911C10.3593 15.911 11.8547 15.2907 13.086 14.05C14.3176 12.8093 14.9333 11.3112 14.9333 9.55567C14.9333 7.80011 14.3176 6.30189 13.086 5.061C11.8547 3.82034 10.3593 3.2 8.6 3.2C6.82844 3.2 5.32256 3.82034 4.08233 5.061C2.84233 6.30189 2.22233 7.80011 2.22233 9.55567C2.22233 11.3112 2.84233 12.8093 4.08233 14.05C5.32256 15.2907 6.82844 15.911 8.6 15.911Z" fill="#1A1A1A"/>
  </svg>`;

  modal.classList.add("active");

  modal.innerHTML = `
    <div class="modal-content">
      <div class="modal-header">
        <button onclick="closeModal()" type="button" style="background: none; border: none; cursor: pointer; padding: 8px; color: #666; margin-left: auto;">
          ${closeIcon}
        </button>
        <h2 class="modal-title">Adicionar novo endereço</h2>
      </div>
      <div class="modal-subtitle" style="margin-bottom: 24px;">
        <span>Preencha o CEP para continuar com o cadastro do endereço.</span>
      </div>
      <form id="address-form" onsubmit="submitAddressForm(event)" class="modal-body">
        <div class="modal-inputs">
          <label for="address-cep">CEP *</label>
          <div class="cep-input-container" style="position: relative; display: flex; align-items: center;">
            <input
              id="address-cep"
              type="text"
              placeholder="00000-000"
              maxlength="9"
              required
              oninput="maskCep(event)"
              onkeypress="if(event.key==='Enter'){event.preventDefault();searchCep();}"
              style="flex: 1; padding-right: 45px;"
            >
            <button type="button" onclick="searchCep()" style="position: absolute; right: 8px; background: none; border: none; cursor: pointer; padding: 8px; display: flex; align-items: center; justify-content: center;">
              ${searchIcon}
            </button>
          </div>

          <label for="address-street">Logradouro *</label>
          <input
            id="address-street"
            type="text"
            placeholder="Digite o endereço"
            oninput="addressHandler(event)"
            required
            disabled
          >

          <label for="address-complement">Complemento</label>
          <input
            id="address-complement"
            type="text"
            placeholder="Digite o complemento"
            oninput="addressHandler(event)"
            disabled
          >
          
          <div class="modal-fields-hor">
            <div class="modal-fields">
              <label for="address-state">Estado *</label>
              <select id="address-state" required disabled>
                <option value="">Selecione</option>
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AP">AP</option>
                <option value="AM">AM</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MT">MT</option>
                <option value="MS">MS</option>
                <option value="MG">MG</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PR">PR</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RS">RS</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="SC">SC</option>
                <option value="SP">SP</option>
                <option value="SE">SE</option>
                <option value="TO">TO</option>
              </select>
            </div>
            <div class="modal-fields">
              <label for="address-city">Cidade *</label>
              <input
                id="address-city"
                type="text"
                placeholder="Digite a cidade"
                oninput="addressHandler(event)"
                required
                disabled
              >
            </div>
          </div>
          
          <div class="modal-fields-hor">
            <div class="modal-fields">
              <label for="address-number">Número *</label>
              <input
                id="address-number"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                oninput="numberOnlyHandler(event)"
                placeholder="123"
                required
                disabled
              >
            </div>
            <div class="modal-fields">
              <label for="address-neighborhood">Bairro *</label>
              <input
                id="address-neighborhood"
                type="text"
                placeholder="Digite o bairro"
                oninput="addressHandler(event)"
                required
                disabled
              >
            </div>
          </div>
        </div>
        
        <div class="address-btns">
          <button type="button" onclick="closeModal()" class="custom-main-btn outlined">Cancelar</button>
          <button type="submit" class="custom-main-btn">Salvar Endereço</button>
        </div>
      </form>
      
      <p id="address-error-message" style="color: red; font-size: 16px; margin-top: 16px; display: none; text-align: center;"></p>
    </div>
  `;

  setTimeout(() => {
    const cepInput = document.getElementById("address-cep");
    if (cepInput) cepInput.focus();
  }, 100);
}

function showAddressError(message) {
  const errorElement = document.getElementById('address-error-message');
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = 'block';

    setTimeout(() => {
      hideAddressError();
    }, 5000);
  }
}

function hideAddressError() {
  const errorElement = document.getElementById('address-error-message');
  if (errorElement) {
    errorElement.style.display = 'none';
    errorElement.textContent = '';
  }
}

function addressHandler(event) {
  let value = event.target.value;
  value = String(value)
    .toUpperCase()
    .replaceAll(/[^a-zA-Z0-9\d\s:]/g, '');

  event.target.value = value;
}

function numberOnlyHandler(event) {
  event.target.value = event.target.value.replace(/[^0-9]/g, '');
}

function maskCep(event) {
  let value = event.target.value.replace(/\D/g, "");
  if (value.length > 8) value = value.slice(0, 8);
  if (value.length > 5) {
    value = value.replace(/(\d{5})(\d{1,3})/, "$1-$2");
  }
  event.target.value = value;
  hideAddressError();
}

async function searchCep() {
  const defaultErrorMessage = "CEP não encontrado. Você pode preencher o endereço manualmente.";
  const cepInput = document.getElementById("address-cep");
  const cep = cepInput.value.replace(/\D/g, "");

  if (cep.length !== 8) {
    showAddressError("Digite um CEP válido com 8 números");
    return;
  }

  const searchBtn = event.target || document.querySelector('.cep-input-container button');
  const originalContent = searchBtn.innerHTML;
  searchBtn.disabled = true;
  searchBtn.innerHTML = `<div style="width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #1A1A1A; border-radius: 50%; animation: spin 1s linear infinite;"></div>`;

  if (!document.getElementById('spinner-style')) {
    const style = document.createElement('style');
    style.id = 'spinner-style';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }
  hideAddressError();
  clearFormFields();

  try {
    if (!organizationData) throw new Error(`Não foi possível obter os dados da organização.`);

    const response = await fetch(`https://viacep.com.br/ws/${cep}/json`);
    const data = await response.json();

    if (!data.erro) {
      lastSearchedCep = data;
      if (organizationData.billingAddress.state != data.uf) {
        showAddressError("O endereço de entrega não pode estar em um Estado diferente do Endereço de Faturamento. Gentileza, revisar o CEP.");
        disableAddressInputs();

        return;
      }
      fillAddressFields(data);
    } else {
      lastSearchedCep = {
        cep,
        erro: true,
      };
      fillAddressFields();
      showAddressError(defaultErrorMessage);
    }
  } catch (error) {
    fillAddressFields();
    showAddressError(error.message || defaultErrorMessage);
  } finally {
    searchBtn.disabled = false;
    searchBtn.innerHTML = originalContent;
  }
}

function disableAddressInputs() {
  const fields = [
    "address-street",
    "address-city",
    "address-state",
    "address-neighborhood",
    "address-complement",
    "address-number",
  ];

  fields.forEach((field) => {
    const element = document.getElementById(field);
    if (element) element.disabled = true;
  });
}

function fillAddressFields(data) {
  const addressFields = ['address-complement', 'address-number'];

  if (data) {
    const zipRelatedFields = [
      { id: "address-street", value: String(data.logradouro).toUpperCase() },
      { id: "address-city", value: String(data.localidade).toUpperCase() },
      { id: "address-state", value: data.uf },
      { id: "address-neighborhood", value: String(data.bairro).toUpperCase() },
    ];

    zipRelatedFields.forEach((field) => {
      const element = document.getElementById(field.id);
      if (element) {
        if (field.value && field.value !== 'UNDEFINED') {
          element.value = field.value;
          element.disabled = true;
        } else {
          element.value = '';
          element.disabled = false;
        }
      }
    });
  } else {
    const zipRelatedFields = [
      "address-street",
      "address-city",
      "address-state",
      "address-neighborhood"
    ];

    zipRelatedFields.forEach((field) => {
      const element = document.getElementById(field);
      if (element) element.disabled = false;
    });
  }

  hideAddressError();

  addressFields.forEach(field => {
    const element = document.getElementById(field);
    if (element) element.disabled = false;
  });

  const numberInput = document.getElementById("address-number");
  if (numberInput) {
    setTimeout(() => numberInput.focus(), 100);
  }
}

async function submitAddressForm(event) {
  event.preventDefault();

  const formButtons = document.querySelectorAll("#address-form .address-btns .custom-main-btn");
  formButtons.forEach(button => {
    button.classList.add("loading");
    button.disabled = true;
  });

  try {
    if (!organizationData) throw new Error(`Não foi possível obter os dados da organização.`);

    hideAddressError();

    const formData = {
      cep: document.getElementById("address-cep").value.trim(),
      street: document.getElementById("address-street").value.trim(),
      complement: document.getElementById("address-complement").value.trim(),
      city: document.getElementById("address-city").value.trim(),
      state: document.getElementById("address-state").value.trim(),
      number: document.getElementById("address-number").value.trim(),
      neighborhood: document.getElementById("address-neighborhood").value.trim(),
    };

    // Validação
    const emptyFields = [];
    const fieldNames = {
      cep: "CEP",
      street: "Logradouro",
      city: "Cidade",
      state: "Estado",
      number: "Número",
      neighborhood: "Bairro"
    };

    Object.entries(formData).forEach(([key, value]) => {
      if (!value && fieldNames[key]) emptyFields.push(fieldNames[key]);
    });

    if (emptyFields.length > 0)
      throw { message: `Preencha todos os campos obrigatórios: ${emptyFields.join(", ")}` };

    validateStreetName(formData.street);
    validateFormDataWithCep(formData);

    const response = await fetch(`https://viacep.com.br/ws/${formData.cep}/json`);
    const cepData = await response.json();

    if (cepData.erro) {
      if (organizationData.billingAddress.state != formData.state)
        throw { message: "O estado do endereço não pode ser diferente do estado de faturamento da empresa." };
    } else if (cepData.uf != formData.state) {
      throw { message: "O estado do endereço não pode ser diferente do estado de faturamento da empresa." };
    }

    const token = await login();

    const addressResponse = await fetch(`${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations/addresses?customerId=${customerId}`, {
      body: JSON.stringify({
        zip: formData.cep.replace('-', ''),
        street: formData.street,
        complement: formData.complement,
        city: formData.city,
        state: formData.state,
        number: formData.number,
        neighborhood: formData.neighborhood,
      }),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });

    if (!addressResponse.ok)
      throw { message: "Não foi possível adicionar o endereço à organização." };

    if (addressResponse.ok) {
      showToast('success', 'Endereço cadastrado com sucesso.', 'FECHAR');

      const { shippingAddress: newAddress } = await addressResponse.json();
      if (newAddress) renderAccountAddresses([newAddress]);

      closeModal();
    }
  } catch (error) {
    showAddressError(error.message);
  } finally {
    formButtons.forEach(button => {
      button.classList.remove("loading");
      button.disabled = false;
    });
  }
}

window.openAddressModal = openAddressModal;
window.closeModal = function () {
  const modal = document.querySelector('.custom-modal');
  if (modal) {
    modal.classList.remove('active');
    modal.innerHTML = '';
  }
};

function validateStreetName(streetName) {
  const trimmedStreetName = String(streetName || "").trim();

  if (!trimmedStreetName) {
    throw { message: "O logradouro não pode ser vazio." };
  }

  const hasLetters = /[A-Za-zÀ-ÿ]/.test(trimmedStreetName);
  if (!hasLetters) {
    throw { message: "O logradouro deve conter pelo menos uma letra."};
  }
}

function normalizeCep(cep) {
  return String(cep || '').replace(/\D/g, '');
}

function normalizeText(s) {
  return String(s || '')
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
}

function validateFormDataWithCep(formData) {
  if (!lastSearchedCep) throw { message: 'Busque o CEP antes de salvar.' };

  const lastCep = normalizeCep(lastSearchedCep.cep);
  const formCep = normalizeCep(formData.cep);

  if (lastCep !== formCep)
    throw { message: 'O campo de cep foi alterado sem refazer a pesquisa. Busque novamente o cep por favor.' };

  if (lastSearchedCep.erro) return;

  if (lastCep.endsWith('000')) {
    const mismatches = [];
    if (normalizeText(formData.city) !== normalizeText(lastSearchedCep.localidade)) mismatches.push('Cidade');
    if (normalizeText(formData.state) !== normalizeText(lastSearchedCep.uf)) mismatches.push('Estado');
    if (mismatches.length > 0)
      throw { message: `Os campos ${mismatches.join(', ')} não correspondem ao CEP ${formData.cep} pesquisado.` };
    return;
  }

  const differentFields = [];
  if (lastSearchedCep.logradouro && normalizeText(formData.street) !== normalizeText(lastSearchedCep.logradouro))
    differentFields.push('Logradouro');
  if (lastSearchedCep.localidade && normalizeText(formData.city) !== normalizeText(lastSearchedCep.localidade))
    differentFields.push('Cidade');
  if (lastSearchedCep.uf && normalizeText(formData.state) !== normalizeText(lastSearchedCep.uf))
    differentFields.push('Estado');
  if (lastSearchedCep.bairro && normalizeText(formData.neighborhood) !== normalizeText(lastSearchedCep.bairro))
    differentFields.push('Bairro');

  if (differentFields.length > 0)
    throw { message: `Os campos ${differentFields.join(', ')} não estão de acordo com o CEP ${formData.cep} pesquisado.` };
}

function clearFormFields() {
  document.getElementById("address-street").value = "";
  document.getElementById("address-complement").value = "";
  document.getElementById("address-city").value = "";
  document.getElementById("address-state").value = "";
  document.getElementById("address-number").value = "";
  document.getElementById("address-neighborhood").value = "";
}